export type BodyColor = keyof typeof BODY_COLORS
export type Color = keyof typeof COLORS

export type Lang = `${LANG}`
export type ShortLang = `${SHORT_LANG}`

export const PREVIEW_DOCUMENT_ID_COOKIE = 'io.prismic.preview.documentId'
export const REPO_NAME = 'very-f-ing-real'
export const LANG_COOKIE = 'lang'

export enum SHORT_LANG {
	'de-ch' = 'de',
	'en-eu' = 'en'
}

export enum LANG {
	de = 'de-ch',
	en = 'en-eu'
}

export enum COLORS {
	'ultra yellow' = '#E5FC54',
	'multiverse blue' = '#2943BE',
	'lilac dream' = '#C294FF',
	'sassy flamingo' = '#FF70FE',
	'super lime' = '#32FE6B',
	'wavy navy' = '#014051',
	'angry tomato' = '#FE5D02',
	'spilled merlot' = '#680031'
}

export enum SELECTION_COLORS {
	'ultra yellow' = 'black',
	'multiverse blue' = 'white',
	'lilac dream' = 'black',
	'sassy flamingo' = 'black',
	'super lime' = 'black',
	'wavy navy' = 'white',
	'angry tomato' = 'white',
	'spilled merlot' = 'white'
}

export enum BODY_COLORS {
	white = '#F5F5F5',
	black = '#000000'
}

export const DIST_FOLDER = 'dist'
export const STATIC_FOLDER = 'static'
